<template>
  <div class="alert-sub-user">
    <Alert dense outlined type="warning" icon="warning-system" regular-title class="alert-sub-user__alert">
      <template #title>
        <span class="alert-sub-user__title" :class="computedSize">
          {{ computedMessage }}
        </span>
      </template>
    </Alert>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Alert from '@/components/Alert.vue';

@Component({
  components: { Alert },
})
export default class AlertSubUserPayment extends Vue {
  @Prop(String)
  message?: string;

  @Prop(String)
  size?: 'small' | 'default';

  get computedSize(): string {
    if (this.size === 'small') {
      return 'body-2';
    }
    return '';
  }

  get computedMessage(): string {
    if (this.message) {
      return this.message;
    }
    return this.$t('fields.account.sub_user.only_admin_can_change_plan').toString();
  }
}
</script>

<style lang="scss" scoped>
.alert-sub-user {
  display: flex;
  justify-content: center;
  width: 100%;

  &__alert {
    max-width: 655px;
    width: 100%;
  }

  &__title {
    color: map-get($lapis, 'lighten-1');
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
